import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import { compose } from 'redux'
import PropTypes from 'prop-types'
import { getParamsFromQueryString } from '../../utils/url'

import {
  formContainer,
  titleContainer,
  mainTitle,
  buttonContainer
} from './styles/LoginForm.style'

import { Button } from '../shared/styles/Button.style'
import Input from '../shared/Input'

import * as validators from '../../utils/validators'
import * as normalizers from '../../utils/normalizers'
import { Box, CircularProgress, Modal, Typography } from '@mui/material'
import { modal, closeBtn } from './styles/SignUpForm.style'
import CloseIcon from '@mui/icons-material/Close'
import { getCurrentAppData } from '../../utils/fractalApps'
import { allowedAppIds, isStaging } from '../../utils/constants'

const SignUpForm = ({
  onSubmit,
  isSubmitting,
  translation,
  lang,
  isSuccess
}) => {
  const { email: emailValue, app_id: appId } = getParamsFromQueryString()
  const registerTitle = appId === '33' ? 'Registar' : translation('register')['registerTitle']
  const required = lang === 'pt-BR' ? validators.requiredPT : validators.requiredES
  const passwordConfirmation = lang === 'pt-BR' ? validators.passwordConfirmationPT : validators.passwordConfirmationES
  const passwordLength = lang === 'pt-BR' ? validators.passwordLengthPT : validators.passwordLengthES
  const email = lang === 'pt-BR' ? validators.emailPT : validators.emailES
  const fullnameLength = lang === 'pt-BR' ? validators.fullnameLengthPT : validators.fullnameLengthES
  const validFullname = lang === 'pt-BR' ? validators.validFullnamePT : validators.validFullnameES
  const noSpecialChars = lang === 'pt-BR' ? validators.noSpecialCharsPT : validators.noSpecialCharsES
  const phoneValidation = lang === 'pt-BR' ? validators.phoneValidationBR : validators.phoneValidationPAR
  const normalizePhone = lang === 'pt-BR' ? normalizers.normalizePhoneBRA : normalizers.normalizePhonePAR

  // array of applicationIds
  const showOpenExamFields = ['38', '40', '41']
  const [open, setOpen] = useState(false)
  const appData = getCurrentAppData()
  const handleClose = () => {
    setOpen(false)
    window.location.href = appData.redirectUrl
  }
  const [isDisabled, setIsDisabled] = useState(true)

  const { control, getValues, handleSubmit } = useForm({
    defaultValues: {
      name: '',
      email: emailValue || '',
      password: '',
      passwordConfirmation: ''
    }
  })

  const handleRegisterButton = () => {
    if (!isStaging && allowedAppIds.includes(appId)) {
      setOpen(true)
    }
  }

  useEffect(() => {
    if (isSuccess && !isSubmitting) {
      window.location.href = appData.redirectUrl
    }
  }, [isSuccess, isSubmitting])

  const checkInputs = () => {
    const inputs = document.querySelectorAll('input')
    let isAllFilled = true
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i].value === '') {
        isAllFilled = false
        break
      }
    }
    setIsDisabled(!isAllFilled)
  }

  return (
    <form
      id='signUpForm'
      className={formContainer}
      onSubmit={handleSubmit(onSubmit)}
    >
      <header className={titleContainer}>
        <h1 className={mainTitle}>{registerTitle}</h1>
      </header>

      <div>
        <div>
          <Input
            id='fullname'
            control={control}
            name='name'
            rules={{
              validate: validators.composeValidators(
                required,
                noSpecialChars,
                fullnameLength,
                validFullname
              )
            }}
            normalizers={[normalizers.normalizeFullname]}
            placeholder={translation('register')['namePlaceholder']}
            type='text'
            block
            onValueChange={checkInputs}
          />
        </div>

        <div>
          <Input
            id='email'
            control={control}
            name='email'
            rules={{ validate: validators.composeValidators(required, email) }}
            placeholder={translation('register')['emailPlaceholder']}
            type='email'
            block
            disabled={Boolean(emailValue)}
            onValueChange={checkInputs}
          />
        </div>

        {showOpenExamFields.includes(appId) && (<>
          <div>
            <Input
              id='city'
              control={control}
              name='additional_data.address.city'
              rules={{ validate: validators.composeValidators(required) }}
              normalizers={[normalizers.normalizeFullname]}
              placeholder={translation('editUserForm')['cityLabel']}
              type='text'
              block
            />
          </div>
          <div>
            <Input
              id='state'
              control={control}
              name='additional_data.address.state'
              rules={{ validate: validators.composeValidators(required) }}
              normalizers={[normalizers.normalizeFullname]}
              placeholder={translation('editUserForm')['stateLabel']}
              type='text'
              block
            />
          </div>
          <div>
            <Input
              id='phone'
              control={control}
              name='phone'
              rules={{ validate: validators.composeValidators(required, phoneValidation) }}
              normalizers={[normalizePhone]}
              placeholder={translation('editUserForm')['phoneLabel']}
              type='text'
              block
            />
          </div>
        </>)}
        <div>
          <Input
            control={control}
            name='password'
            rules={{ validate: validators.composeValidators(required, passwordLength) }}
            placeholder={translation('register')['passwordPlaceholder']}
            type='password'
            block
            onValueChange={checkInputs}
          />
        </div>

        <div>
          <Input
            control={control}
            name='passwordConfirmation'
            rules={{ validate: validators.composeValidators(required, passwordConfirmation(getValues)) }}
            placeholder={translation('register')['confirmPasswordPlaceholder']}
            type='password'
            block
            onValueChange={checkInputs}
          />
        </div>
      </div>

      <div className={buttonContainer}>
        <Button
          type='submit'
          disabled={isSubmitting || isDisabled}
          onClick={handleRegisterButton}
        >
          {registerTitle}
          {isSubmitting ? <CircularProgress size={20} style={{ color: 'white', marginLeft: 10 }} /> : ''}
        </Button>
      </div>
      {
        (!isStaging && isSuccess && allowedAppIds.includes(appId)) ? (
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby='modal-modal-title'
            aria-describedby='modal-modal-description'
          >
            <Box className={modal}>
              <Button className={closeBtn}
                onClick={handleClose}
              >
                <CloseIcon className={closeBtn} />
              </Button>
              <Typography id='modal-modal-title' variant='h6' component='h2'>
                Confirmação de Email:
              </Typography>
              <Typography id='modal-modal-description'>
                Verifique seu email para confirmação de cadastro.
              </Typography>
            </Box>
          </Modal>
        ) : ''
      }

    </form>
  )
}

SignUpForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  translation: PropTypes.func.isRequired,
  isSuccess: PropTypes.bool,
  lang: PropTypes.string.isRequired
}

const mapStateToProps = ({ auth }) => ({
  isSubmitting: auth.isFetching,
  isSuccess: auth.isSuccess
})

const enhance = compose(
  connect(mapStateToProps)
)

export default enhance(SignUpForm)
